export default __webpack_public_path__ + "static/media/CREATE.77ca25fd.png";